import React, { Component } from 'react';
import { Provider, observer } from 'mobx-react';
import { history } from "../../history_mobx";
import myStore from "../../stores/store";
import { Router } from "react-router";
import LastCommentsWithStore from "./LastCommentsWithStore";
import { Switch, Route, NavLink } from "react-router-dom";


class CommentsOnly extends Component {
  render() {
    return (
      <Provider {...myStore.getStores()}>
          <Router history={history}>
            <div></div>
            {this.props.type?(
              <LastCommentsWithStore {...this.props} standalone={true} />
            ):(
              <Switch>
                <Route exact path="/last_comments/my/"  render={(props)=>{ return ( <LastCommentsWithStore type="my" {...this.props} standalone={true} /> ); } } />
                <Route exact path="/last_comments/spy/"  render={(props)=>{ return ( <LastCommentsWithStore type="spy" {...this.props} standalone={true} /> ); } } />
                <Route exact path="/last_comments/follow/"  render={(props)=>{ return ( <LastCommentsWithStore type="follow" {...this.props} standalone={true} /> ); } } />
                <Route exact path="/last_comments/your/"  render={(props)=>{ return ( <LastCommentsWithStore type="your" {...this.props} standalone={true} /> ); } } />
              </Switch>
            )}
          </Router>
      </Provider>
    );
  }
}

export default observer(CommentsOnly);
